export default __webpack_public_path__ + "329746577f94a4f1785ee927355989aa.otf";